type Literal = number | string;

interface Options<T extends Literal> {
  value: any;
  enums: Readonly<T[]>;
  fallback: T;
}

export const literal = <T extends Literal>({ value, enums, fallback }: Options<T>) => {
  return enums.includes(value) ? (value as T) : fallback;
};
